import { useEffect } from "react";
import useCurrentUser from "../../../../hooks/local-storage/use-current-user";
import { useGetNotificationPreferences } from "../../../../queries/notification/use-get-notification-preferences";
import { useSaveNotificationPreferences } from "../../../../queries/notification/use-save-notification-preferences";
import NotificationTable from "../../../../pages/app/provider/settings/account-setting/NotificationTable";

const PatientPortalNotifications = () => {
  const [patient] = useCurrentUser();
  const patientUuid = patient?.uuid ?? "";

  const {
    data: preferencesData,
    isFetching,
    isPending,
    isLoading,
  } = useGetNotificationPreferences(patientUuid);

  const { preferences, setList, onChangePreference } =
    useSaveNotificationPreferences({ patientUuid });

  useEffect(() => {
    if (preferencesData) {
      const items = Array.isArray(preferencesData?.data?.content)
        ? preferencesData?.data?.content
        : ((preferencesData as any)?.data?.content ?? []);
      setList(items);
    }
  }, [preferencesData, setList]);

  return (
    <NotificationTable
      list={preferences}
      loading={isFetching || isPending || isLoading}
      onChangePreference={onChangePreference}
      customHeight={"calc(100vh - 150px)"}
    />
  );
};

export default PatientPortalNotifications;
